import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "col-lg-12" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Wizard Form"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview-tab",
              tabindex: "0"
            }, [
              _createElementVNode("ul", {
                class: "nav nav-tabs justify-content-between border-0 mb-4 wizard-tabs",
                id: "myTabstep",
                role: "tablist"
              }, [
                _createElementVNode("li", {
                  class: "nav-item",
                  role: "presentation"
                }, [
                  _createElementVNode("button", {
                    class: "nav-link wh-48 bg-primary bg-opacity-10 rounded-circle p-0 active",
                    id: "step1-tab",
                    "data-bs-toggle": "tab",
                    "data-bs-target": "#step1-tab-pane",
                    type: "button",
                    role: "tab",
                    "aria-controls": "step1-tab-pane",
                    "aria-selected": "true"
                  }, [
                    _createElementVNode("span", { class: "fs-20 fw-bold text-primary" }, "1")
                  ])
                ]),
                _createElementVNode("li", {
                  class: "nav-item",
                  role: "presentation"
                }, [
                  _createElementVNode("button", {
                    class: "nav-link wh-48 bg-primary bg-opacity-10 rounded-circle p-0",
                    id: "step2-tab",
                    "data-bs-toggle": "tab",
                    "data-bs-target": "#step2-tab-pane",
                    type: "button",
                    role: "tab",
                    "aria-controls": "step2-tab-pane",
                    "aria-selected": "false"
                  }, [
                    _createElementVNode("span", { class: "fs-20 fw-bold text-primary" }, "2")
                  ])
                ]),
                _createElementVNode("li", {
                  class: "nav-item",
                  role: "presentation"
                }, [
                  _createElementVNode("button", {
                    class: "nav-link wh-48 bg-primary bg-opacity-10 rounded-circle p-0",
                    id: "step3-tab",
                    "data-bs-toggle": "tab",
                    "data-bs-target": "#step3-tab-pane",
                    type: "button",
                    role: "tab",
                    "aria-controls": "step3-tab-pane",
                    "aria-selected": "false"
                  }, [
                    _createElementVNode("span", { class: "fs-20 fw-bold text-primary" }, "3")
                  ])
                ]),
                _createElementVNode("li", {
                  class: "nav-item",
                  role: "presentation"
                }, [
                  _createElementVNode("button", {
                    class: "nav-link wh-48 bg-primary bg-opacity-10 rounded-circle p-0",
                    id: "step4-tab",
                    "data-bs-toggle": "tab",
                    "data-bs-target": "#step4-tab-pane",
                    type: "button",
                    role: "tab",
                    "aria-controls": "step4-tab-pane",
                    "aria-selected": "false"
                  }, [
                    _createElementVNode("span", { class: "fs-20 fw-bold text-primary" }, "4")
                  ])
                ])
              ]),
              _createElementVNode("div", {
                class: "tab-content",
                id: "myTabstepContent"
              }, [
                _createElementVNode("div", {
                  class: "tab-pane fade show active",
                  id: "step1-tab-pane",
                  role: "tabpanel",
                  "aria-labelledby": "step1-tab",
                  tabindex: "0"
                }, [
                  _createElementVNode("h4", { class: "fs-18 fw-semibold" }, "General Information"),
                  _createElementVNode("p", { class: "text-gray-light mb-4" }, " Fill all Information as below "),
                  _createElementVNode("form", null, [
                    _createElementVNode("div", { class: "row" }, [
                      _createElementVNode("div", { class: "col-lg-6" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "First Name"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("input", {
                              type: "text",
                              class: "form-control text-dark ps-5 h-55",
                              placeholder: "Enter Name"
                            }),
                            _createElementVNode("i", { class: "ri-user-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-6" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Last Name"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("input", {
                              type: "text",
                              class: "form-control text-dark ps-5 h-55",
                              placeholder: "Enter Name"
                            }),
                            _createElementVNode("i", { class: "ri-user-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-6" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Email Address"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("input", {
                              type: "email",
                              class: "form-control text-dark ps-5 h-55",
                              placeholder: "Enter Email Address"
                            }),
                            _createElementVNode("i", { class: "ri-mail-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-6" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Phone"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("input", {
                              type: "number",
                              class: "form-control text-dark ps-5 h-55",
                              placeholder: "Enter Phone Number"
                            }),
                            _createElementVNode("i", { class: "ri-phone-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-12" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Address"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("input", {
                              type: "number",
                              class: "form-control text-dark ps-5 h-55",
                              placeholder: "Your Location"
                            }),
                            _createElementVNode("i", { class: "ri-map-pin-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-12" }, [
                        _createElementVNode("div", { class: "form-group d-flex gap-3" }, [
                          _createElementVNode("button", { class: "btn btn-primary bg-primary bg-opacity-10 text-primary py-3 px-5 fw-semibold border-0" }, " Back "),
                          _createElementVNode("button", { class: "btn btn-primary py-3 px-5 fw-semibold text-white" }, " Next ")
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "tab-pane fade",
                  id: "step2-tab-pane",
                  role: "tabpanel",
                  "aria-labelledby": "step2-tab",
                  tabindex: "0"
                }, [
                  _createElementVNode("h4", { class: "fs-18 fw-semibold" }, "Personal Information"),
                  _createElementVNode("p", { class: "text-gray-light mb-4" }, " Fill all Information as below "),
                  _createElementVNode("form", null, [
                    _createElementVNode("div", { class: "row" }, [
                      _createElementVNode("div", { class: "col-lg-12" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Country"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("select", {
                              class: "form-select form-control ps-5 h-55",
                              "aria-label": "Default select example"
                            }, [
                              _createElementVNode("option", {
                                selected: "",
                                class: "text-dark"
                              }, " United Kingdom "),
                              _createElementVNode("option", {
                                value: "1",
                                class: "text-dark"
                              }, " United States "),
                              _createElementVNode("option", {
                                value: "2",
                                class: "text-dark"
                              }, " Canada "),
                              _createElementVNode("option", {
                                value: "3",
                                class: "text-dark"
                              }, " France ")
                            ]),
                            _createElementVNode("i", { class: "ri-map-2-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-4" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Town/City"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("select", {
                              class: "form-select form-control ps-5 h-55",
                              "aria-label": "Default select example"
                            }, [
                              _createElementVNode("option", {
                                selected: "",
                                class: "text-dark"
                              }, " California "),
                              _createElementVNode("option", {
                                value: "1",
                                class: "text-dark"
                              }, " United States "),
                              _createElementVNode("option", {
                                value: "2",
                                class: "text-dark"
                              }, " Canada "),
                              _createElementVNode("option", {
                                value: "3",
                                class: "text-dark"
                              }, " France ")
                            ]),
                            _createElementVNode("i", { class: "ri-list-ordered position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-4" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "State"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("select", {
                              class: "form-select form-control ps-5 h-55",
                              "aria-label": "Default select example"
                            }, [
                              _createElementVNode("option", {
                                selected: "",
                                class: "text-dark"
                              }, " South poal evenue state 4C "),
                              _createElementVNode("option", {
                                value: "1",
                                class: "text-dark"
                              }, " United States "),
                              _createElementVNode("option", {
                                value: "2",
                                class: "text-dark"
                              }, " Canada "),
                              _createElementVNode("option", {
                                value: "3",
                                class: "text-dark"
                              }, " France ")
                            ]),
                            _createElementVNode("i", { class: "ri-font-size position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-4" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Zip Code"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("input", {
                              type: "number",
                              class: "form-control ps-5 text-gray-light h-55",
                              placeholder: "Enter number"
                            }),
                            _createElementVNode("i", { class: "ri-hashtag position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-12" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Order Notes :"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("textarea", {
                              class: "form-control ps-5 text-dark",
                              placeholder: "Some demo text ... ",
                              cols: "30",
                              rows: "5"
                            }),
                            _createElementVNode("i", { class: "ri-information-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20 pt-2" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-12" }, [
                        _createElementVNode("div", { class: "form-group d-flex gap-3" }, [
                          _createElementVNode("button", { class: "btn btn-primary bg-primary bg-opacity-10 text-primary py-3 px-5 fw-semibold border-0" }, " Back "),
                          _createElementVNode("button", { class: "btn btn-primary py-3 px-5 fw-semibold text-white" }, " Next ")
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "tab-pane fade",
                  id: "step3-tab-pane",
                  role: "tabpanel",
                  "aria-labelledby": "step3-tab",
                  tabindex: "0"
                }, [
                  _createElementVNode("h4", { class: "fs-18 fw-semibold" }, "Social Information"),
                  _createElementVNode("p", { class: "text-gray-light mb-4" }, " Fill all Information as below "),
                  _createElementVNode("form", null, [
                    _createElementVNode("div", { class: "row" }, [
                      _createElementVNode("div", { class: "col-lg-6" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Facebook"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("input", {
                              type: "url",
                              class: "form-control text-dark ps-5 h-55",
                              placeholder: "URL"
                            }),
                            _createElementVNode("i", { class: "ri-facebook-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-6" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Twitter"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("input", {
                              type: "url",
                              class: "form-control text-dark ps-5 h-55",
                              placeholder: "URL"
                            }),
                            _createElementVNode("i", { class: "ri-twitter-x-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-6" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Linkedin"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("input", {
                              type: "url",
                              class: "form-control text-dark ps-5 h-55",
                              placeholder: "URL"
                            }),
                            _createElementVNode("i", { class: "ri-linkedin-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-6" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "YouTube"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("input", {
                              type: "url",
                              class: "form-control text-dark ps-5 h-55",
                              placeholder: "URL"
                            }),
                            _createElementVNode("i", { class: "ri-youtube-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-12" }, [
                        _createElementVNode("div", { class: "form-group d-flex gap-3" }, [
                          _createElementVNode("button", { class: "btn btn-primary bg-primary bg-opacity-10 text-primary py-3 px-5 fw-semibold border-0" }, " Back "),
                          _createElementVNode("button", { class: "btn btn-primary py-3 px-5 fw-semibold text-white" }, " Next ")
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "tab-pane fade",
                  id: "step4-tab-pane",
                  role: "tabpanel",
                  "aria-labelledby": "step4-tab",
                  tabindex: "0"
                }, [
                  _createElementVNode("h4", { class: "fs-18 fw-semibold" }, "Any Note"),
                  _createElementVNode("p", { class: "text-gray-light mb-4" }, " Fill all Information as below "),
                  _createElementVNode("form", null, [
                    _createElementVNode("div", { class: "row" }, [
                      _createElementVNode("div", { class: "col-lg-12" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Order Notes :"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("textarea", {
                              class: "form-control ps-5 text-dark",
                              placeholder: "Some demo text ... ",
                              cols: "30",
                              rows: "5"
                            }),
                            _createElementVNode("i", { class: "ri-information-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20 pt-2" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-12" }, [
                        _createElementVNode("div", { class: "form-group" }, [
                          _createElementVNode("button", {
                            type: "submit",
                            class: "btn btn-primary py-3 px-5 fw-semibold text-white"
                          }, " Submit ")
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode"
                }, [
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<ul class=\"nav nav-tabs justify-content-between border-0 mb-4 wizard-tabs\" id=\"myTabstep\" role=\"tablist\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <li class=\"nav-item\" role=\"presentation\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button class=\"nav-link wh-48 bg-primary bg-opacity-10 rounded-circle p-0 active\" id=\"step1-tab\" data-bs-toggle=\"tab\" data-bs-target=\"#step1-tab-pane\" type=\"button\" role=\"tab\" aria-controls=\"step1-tab-pane\" aria-selected=\"true\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <span class=\"fs-20 fw-bold text-primary\">1</span>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </li>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <li class=\"nav-item\" role=\"presentation\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button class=\"nav-link wh-48 bg-primary bg-opacity-10 rounded-circle p-0\" id=\"step2-tab\" data-bs-toggle=\"tab\" data-bs-target=\"#step2-tab-pane\" type=\"button\" role=\"tab\" aria-controls=\"step2-tab-pane\" aria-selected=\"false\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <span class=\"fs-20 fw-bold text-primary\">2</span>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </li>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <li class=\"nav-item\" role=\"presentation\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button class=\"nav-link wh-48 bg-primary bg-opacity-10 rounded-circle p-0\" id=\"step3-tab\" data-bs-toggle=\"tab\" data-bs-target=\"#step3-tab-pane\" type=\"button\" role=\"tab\" aria-controls=\"step3-tab-pane\" aria-selected=\"false\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <span class=\"fs-20 fw-bold text-primary\">3</span>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </li>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <li class=\"nav-item\" role=\"presentation\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button class=\"nav-link wh-48 bg-primary bg-opacity-10 rounded-circle p-0\" id=\"step4-tab\" data-bs-toggle=\"tab\" data-bs-target=\"#step4-tab-pane\" type=\"button\" role=\"tab\" aria-controls=\"step4-tab-pane\" aria-selected=\"false\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <span class=\"fs-20 fw-bold text-primary\">3</span>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </li>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</ul>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<div class=\"tab-content\" id=\"myTabstepContent\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"tab-pane fade show active\" id=\"step1-tab-pane\" role=\"tabpanel\" aria-labelledby=\"step1-tab\" tabindex=\"0\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <h4 class=\"fs-18 fw-semibold\">General Information</h4>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <p class=\"text-gray-light mb-4\">Fill all Information as below</p>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <form>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"row\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">First Name</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <input type=\"text\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"Enter Name\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-user-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Last Name</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <input type=\"text\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"Enter Name\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-user-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Email Address</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <input type=\"email\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"Enter Email Address\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-mail-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Phone</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <input type=\"number\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"Enter Phone Number\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-phone-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Address</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <input type=\"number\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"Your Location\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-map-pin-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group d-flex gap-3\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <button class=\"btn btn-primary bg-primary bg-opacity-10 text-primary py-3 px-5 fw-semibold border-0\">Back</button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <button class=\"btn btn-primary py-3 px-5 fw-semibold text-white\">Next</button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </form>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"tab-pane fade\" id=\"step2-tab-pane\" role=\"tabpanel\" aria-labelledby=\"step2-tab\" tabindex=\"0\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <h4 class=\"fs-18 fw-semibold\">Personal Information</h4>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <p class=\"text-gray-light mb-4\">Fill all Information as below</p>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <form>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"row\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Country</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <select class=\"form-select form-control ps-5 h-55\" aria-label=\"Default select example\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option selected class=\"text-dark\">United Kingdom</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option value=\"1\" class=\"text-dark\">United States</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option value=\"2\" class=\"text-dark\">Canada</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option value=\"3\" class=\"text-dark\">France</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            </select>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-map-2-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Town/City</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <select class=\"form-select form-control ps-5 h-55\" aria-label=\"Default select example\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option selected class=\"text-dark\">California</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option value=\"1\" class=\"text-dark\">United States</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option value=\"2\" class=\"text-dark\">Canada</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option value=\"3\" class=\"text-dark\">France</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            </select>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-list-ordered position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">State</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <select class=\"form-select form-control ps-5 h-55\" aria-label=\"Default select example\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option selected class=\"text-dark\">South poal evenue state 4C</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option value=\"1\" class=\"text-dark\">United States</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option value=\"2\" class=\"text-dark\">Canada</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option value=\"3\" class=\"text-dark\">France</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            </select>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-font-size position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Zip Code</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <input type=\"number\" class=\"form-control ps-5 text-gray-light h-55\" placeholder=\"Enter number\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-hashtag position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Order Notes :</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <textarea class=\"form-control ps-5 text-dark\" placeholder=\"Some demo text ... \" cols=\"30\" rows=\"5\"></textarea>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-information-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20 pt-2\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group d-flex gap-3\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <button class=\"btn btn-primary bg-primary bg-opacity-10 text-primary py-3 px-5 fw-semibold border-0\">Back</button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <button class=\"btn btn-primary py-3 px-5 fw-semibold text-white\">Next</button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </form>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"tab-pane fade\" id=\"step3-tab-pane\" role=\"tabpanel\" aria-labelledby=\"step3-tab\" tabindex=\"0\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <h4 class=\"fs-18 fw-semibold\">Social Information</h4>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <p class=\"text-gray-light mb-4\">Fill all Information as below</p>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <form>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"row\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Facebook</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <input type=\"text\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"URL\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-facebook-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Twitter</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <input type=\"text\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"URL\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-twitter-x-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Linkedin</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <input type=\"email\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"URL\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-linkedin-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">YouTube</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <input type=\"number\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"URL\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-youtube-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group d-flex gap-3\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <button class=\"btn btn-primary bg-primary bg-opacity-10 text-primary py-3 px-5 fw-semibold border-0\">Back</button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <button class=\"btn btn-primary py-3 px-5 fw-semibold text-white\">Next</button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </form>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"tab-pane fade\" id=\"step4-tab-pane\" role=\"tabpanel\" aria-labelledby=\"step4-tab\" tabindex=\"0\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <h4 class=\"fs-18 fw-semibold\">Any Note</h4>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <p class=\"text-gray-light mb-4\">Fill all Information as below</p>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <form>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"row\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Order Notes :</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <textarea class=\"form-control ps-5 text-dark\" placeholder=\"Some demo text ... \" cols=\"30\" rows=\"5\"></textarea>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-information-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20 pt-2\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <button type=\"submit\" class=\"btn btn-primary py-3 px-5 fw-semibold text-white\">Submit</button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </form>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</div>"),
                  _createTextVNode("\n")
                ]),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-12" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab2",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview2-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code2-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTab2Content"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("ul", {
                class: "nav nav-tabs justify-content-between border-0 mb-4 wizard-tabs2",
                id: "myTabstep2",
                role: "tablist"
              }, [
                _createElementVNode("li", {
                  class: "nav-item",
                  role: "presentation"
                }, [
                  _createElementVNode("button", {
                    class: "nav-link p-0 d-flex align-items-center active",
                    id: "step5-tab",
                    "data-bs-toggle": "tab",
                    "data-bs-target": "#step5-tab-pane",
                    type: "button",
                    role: "tab",
                    "aria-controls": "step5-tab-pane",
                    "aria-selected": "true"
                  }, [
                    _createElementVNode("span", { class: "fs-20 fw-bold text-primary wh-48 bg-primary bg-opacity-10 rounded-circle d-inline-block" }, "1"),
                    _createElementVNode("div", { class: "text-start ms-3 d-none d-lg-block" }, [
                      _createElementVNode("h4", { class: "fs-18 fw-semibold" }, "General Information"),
                      _createElementVNode("p", { class: "text-gray-light mb-0" }, " Fill all Information as below ")
                    ])
                  ])
                ]),
                _createElementVNode("li", {
                  class: "nav-item",
                  role: "presentation"
                }, [
                  _createElementVNode("button", {
                    class: "nav-link p-0 d-flex align-items-center",
                    id: "step6-tab",
                    "data-bs-toggle": "tab",
                    "data-bs-target": "#step6-tab-pane",
                    type: "button",
                    role: "tab",
                    "aria-controls": "step6-tab-pane",
                    "aria-selected": "false"
                  }, [
                    _createElementVNode("span", { class: "fs-20 fw-bold text-primary wh-48 bg-primary bg-opacity-10 rounded-circle d-inline-block" }, "2"),
                    _createElementVNode("div", { class: "text-start ms-3 d-none d-lg-block" }, [
                      _createElementVNode("h4", { class: "fs-18 fw-semibold" }, "Personal Info"),
                      _createElementVNode("p", { class: "text-gray-light mb-0" }, "Setup Information")
                    ])
                  ])
                ]),
                _createElementVNode("li", {
                  class: "nav-item",
                  role: "presentation"
                }, [
                  _createElementVNode("button", {
                    class: "nav-link p-0 d-flex align-items-center",
                    id: "step7-tab",
                    "data-bs-toggle": "tab",
                    "data-bs-target": "#step7-tab-pane",
                    type: "button",
                    role: "tab",
                    "aria-controls": "step7-tab-pane",
                    "aria-selected": "false"
                  }, [
                    _createElementVNode("span", { class: "fs-20 fw-bold text-primary wh-48 bg-primary bg-opacity-10 rounded-circle d-inline-block" }, "3"),
                    _createElementVNode("div", { class: "text-start ms-3 d-none d-lg-block" }, [
                      _createElementVNode("h4", { class: "fs-18 fw-semibold" }, "Social Links"),
                      _createElementVNode("p", { class: "text-gray-light mb-0" }, "Add Social Links")
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", {
                class: "tab-content",
                id: "myTabstep2Content"
              }, [
                _createElementVNode("div", {
                  class: "tab-pane fade show active",
                  id: "step5-tab-pane",
                  role: "tabpanel",
                  "aria-labelledby": "step5-tab",
                  tabindex: "0"
                }, [
                  _createElementVNode("form", null, [
                    _createElementVNode("div", { class: "row" }, [
                      _createElementVNode("div", { class: "col-lg-6" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "First Name"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("input", {
                              type: "text",
                              class: "form-control text-dark ps-5 h-55",
                              placeholder: "Enter Name"
                            }),
                            _createElementVNode("i", { class: "ri-user-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-6" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Last Name"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("input", {
                              type: "text",
                              class: "form-control text-dark ps-5 h-55",
                              placeholder: "Enter Name"
                            }),
                            _createElementVNode("i", { class: "ri-user-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-6" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Email Address"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("input", {
                              type: "email",
                              class: "form-control text-dark ps-5 h-55",
                              placeholder: "Enter Email Address"
                            }),
                            _createElementVNode("i", { class: "ri-mail-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-6" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Phone"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("input", {
                              type: "number",
                              class: "form-control text-dark ps-5 h-55",
                              placeholder: "Enter Phone Number"
                            }),
                            _createElementVNode("i", { class: "ri-phone-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-12" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Address"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("input", {
                              type: "number",
                              class: "form-control text-dark ps-5 h-55",
                              placeholder: "Your Location"
                            }),
                            _createElementVNode("i", { class: "ri-map-pin-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-12" }, [
                        _createElementVNode("div", { class: "form-group d-flex gap-3" }, [
                          _createElementVNode("button", { class: "btn btn-primary bg-primary bg-opacity-10 text-primary py-3 px-5 fw-semibold border-0" }, " Back "),
                          _createElementVNode("button", { class: "btn btn-primary py-3 px-5 fw-semibold text-white" }, " Next ")
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "tab-pane fade",
                  id: "step6-tab-pane",
                  role: "tabpanel",
                  "aria-labelledby": "step6-tab",
                  tabindex: "0"
                }, [
                  _createElementVNode("h4", { class: "fs-18 fw-semibold" }, "Personal Information"),
                  _createElementVNode("p", { class: "text-gray-light mb-4" }, " Fill all Information as below "),
                  _createElementVNode("form", null, [
                    _createElementVNode("div", { class: "row" }, [
                      _createElementVNode("div", { class: "col-lg-12" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Country"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("select", {
                              class: "form-select form-control ps-5 h-55",
                              "aria-label": "Default select example"
                            }, [
                              _createElementVNode("option", {
                                selected: "",
                                class: "text-dark"
                              }, " United Kingdom "),
                              _createElementVNode("option", {
                                value: "1",
                                class: "text-dark"
                              }, " United States "),
                              _createElementVNode("option", {
                                value: "2",
                                class: "text-dark"
                              }, " Canada "),
                              _createElementVNode("option", {
                                value: "3",
                                class: "text-dark"
                              }, " France ")
                            ]),
                            _createElementVNode("i", { class: "ri-map-2-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-4" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Town/City"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("select", {
                              class: "form-select form-control ps-5 h-55",
                              "aria-label": "Default select example"
                            }, [
                              _createElementVNode("option", {
                                selected: "",
                                class: "text-dark"
                              }, " California "),
                              _createElementVNode("option", {
                                value: "1",
                                class: "text-dark"
                              }, " United States "),
                              _createElementVNode("option", {
                                value: "2",
                                class: "text-dark"
                              }, " Canada "),
                              _createElementVNode("option", {
                                value: "3",
                                class: "text-dark"
                              }, " France ")
                            ]),
                            _createElementVNode("i", { class: "ri-list-ordered position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-4" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "State"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("select", {
                              class: "form-select form-control ps-5 h-55",
                              "aria-label": "Default select example"
                            }, [
                              _createElementVNode("option", {
                                selected: "",
                                class: "text-dark"
                              }, " South poal evenue state 4C "),
                              _createElementVNode("option", {
                                value: "1",
                                class: "text-dark"
                              }, " United States "),
                              _createElementVNode("option", {
                                value: "2",
                                class: "text-dark"
                              }, " Canada "),
                              _createElementVNode("option", {
                                value: "3",
                                class: "text-dark"
                              }, " France ")
                            ]),
                            _createElementVNode("i", { class: "ri-font-size position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-4" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Zip Code"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("input", {
                              type: "number",
                              class: "form-control ps-5 text-gray-light h-55",
                              placeholder: "Enter number"
                            }),
                            _createElementVNode("i", { class: "ri-hashtag position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-12" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Order Notes :"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("textarea", {
                              class: "form-control ps-5 text-dark",
                              placeholder: "Some demo text ... ",
                              cols: "30",
                              rows: "5"
                            }),
                            _createElementVNode("i", { class: "ri-information-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20 pt-2" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-12" }, [
                        _createElementVNode("div", { class: "form-group d-flex gap-3" }, [
                          _createElementVNode("button", { class: "btn btn-primary bg-primary bg-opacity-10 text-primary py-3 px-5 fw-semibold border-0" }, " Back "),
                          _createElementVNode("button", { class: "btn btn-primary py-3 px-5 fw-semibold text-white" }, " Next ")
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "tab-pane fade",
                  id: "step7-tab-pane",
                  role: "tabpanel",
                  "aria-labelledby": "step7-tab",
                  tabindex: "0"
                }, [
                  _createElementVNode("h4", { class: "fs-18 fw-semibold" }, "Social Information"),
                  _createElementVNode("p", { class: "text-gray-light mb-4" }, " Fill all Information as below "),
                  _createElementVNode("form", null, [
                    _createElementVNode("div", { class: "row" }, [
                      _createElementVNode("div", { class: "col-lg-6" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Facebook"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("input", {
                              type: "text",
                              class: "form-control text-dark ps-5 h-55",
                              placeholder: "URL"
                            }),
                            _createElementVNode("i", { class: "ri-facebook-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-6" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Twitter"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("input", {
                              type: "text",
                              class: "form-control text-dark ps-5 h-55",
                              placeholder: "URL"
                            }),
                            _createElementVNode("i", { class: "ri-twitter-x-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-6" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "Linkedin"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("input", {
                              type: "email",
                              class: "form-control text-dark ps-5 h-55",
                              placeholder: "URL"
                            }),
                            _createElementVNode("i", { class: "ri-linkedin-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-6" }, [
                        _createElementVNode("div", { class: "form-group mb-4" }, [
                          _createElementVNode("label", { class: "label" }, "YouTube"),
                          _createElementVNode("div", { class: "form-group position-relative" }, [
                            _createElementVNode("input", {
                              type: "number",
                              class: "form-control text-dark ps-5 h-55",
                              placeholder: "URL"
                            }),
                            _createElementVNode("i", { class: "ri-youtube-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-lg-12" }, [
                        _createElementVNode("div", { class: "form-group d-flex gap-3" }, [
                          _createElementVNode("button", { class: "btn btn-primary bg-primary bg-opacity-10 text-primary py-3 px-5 fw-semibold border-0" }, " Back "),
                          _createElementVNode("button", {
                            type: "submit",
                            class: "btn btn-primary py-3 px-5 fw-semibold text-white"
                          }, " Submit ")
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode2"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode2"
                }, [
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<ul class=\"nav nav-tabs justify-content-between border-0 mb-4 wizard-tabs2\" id=\"myTabstep2\" role=\"tablist\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <li class=\"nav-item\" role=\"presentation\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button class=\"nav-link p-0 d-flex align-items-center active\" id=\"step5-tab\" data-bs-toggle=\"tab\" data-bs-target=\"#step5-tab-pane\" type=\"button\" role=\"tab\" aria-controls=\"step5-tab-pane\" aria-selected=\"true\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <span class=\"fs-20 fw-bold text-primary wh-48 bg-primary bg-opacity-10 rounded-circle d-inline-block\">1</span>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"text-start ms-3\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <h4 class=\"fs-18 fw-semibold\">General Information</h4>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <p class=\"text-gray-light mb-0\">Fill all Information as below</p>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </li>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <li class=\"nav-item\" role=\"presentation\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button class=\"nav-link p-0 d-flex align-items-center\" id=\"step6-tab\" data-bs-toggle=\"tab\" data-bs-target=\"#step6-tab-pane\" type=\"button\" role=\"tab\" aria-controls=\"step6-tab-pane\" aria-selected=\"false\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <span class=\"fs-20 fw-bold text-primary wh-48 bg-primary bg-opacity-10 rounded-circle d-inline-block\">2</span>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"text-start ms-3\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <h4 class=\"fs-18 fw-semibold\">Personal Info</h4>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <p class=\"text-gray-light mb-0\">Setup Information</p>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </li>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <li class=\"nav-item\" role=\"presentation\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button class=\"nav-link p-0 d-flex align-items-center\" id=\"step7-tab\" data-bs-toggle=\"tab\" data-bs-target=\"#step7-tab-pane\" type=\"button\" role=\"tab\" aria-controls=\"step7-tab-pane\" aria-selected=\"false\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <span class=\"fs-20 fw-bold text-primary wh-48 bg-primary bg-opacity-10 rounded-circle d-inline-block\">3</span>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"text-start ms-3\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <h4 class=\"fs-18 fw-semibold\">Social Links</h4>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <p class=\"text-gray-light mb-0\">Add Social Links</p>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </li>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</ul>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<div class=\"tab-content\" id=\"myTabstep2Content\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"tab-pane fade show active\" id=\"step5-tab-pane\" role=\"tabpanel\" aria-labelledby=\"step5-tab\" tabindex=\"0\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <form>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"row\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">First Name</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <input type=\"text\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"Enter Name\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-user-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Last Name</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <input type=\"text\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"Enter Name\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-user-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Email Address</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <input type=\"email\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"Enter Email Address\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-mail-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Phone</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <input type=\"number\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"Enter Phone Number\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-phone-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Address</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <input type=\"number\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"Your Location\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-map-pin-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group d-flex gap-3\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <button class=\"btn btn-primary bg-primary bg-opacity-10 text-primary py-3 px-5 fw-semibold border-0\">Back</button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <button class=\"btn btn-primary py-3 px-5 fw-semibold text-white\">Next</button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </form>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"tab-pane fade\" id=\"step6-tab-pane\" role=\"tabpanel\" aria-labelledby=\"step6-tab\" tabindex=\"0\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <h4 class=\"fs-18 fw-semibold\">Personal Information</h4>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <p class=\"text-gray-light mb-4\">Fill all Information as below</p>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <form>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"row\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Country</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <select class=\"form-select form-control ps-5 h-55\" aria-label=\"Default select example\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option selected class=\"text-dark\">United Kingdom</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option value=\"1\" class=\"text-dark\">United States</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option value=\"2\" class=\"text-dark\">Canada</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option value=\"3\" class=\"text-dark\">France</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            </select>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-map-2-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Town/City</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <select class=\"form-select form-control ps-5 h-55\" aria-label=\"Default select example\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option selected class=\"text-dark\">California</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option value=\"1\" class=\"text-dark\">United States</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option value=\"2\" class=\"text-dark\">Canada</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option value=\"3\" class=\"text-dark\">France</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            </select>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-list-ordered position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">State</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <select class=\"form-select form-control ps-5 h-55\" aria-label=\"Default select example\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option selected class=\"text-dark\">South poal evenue state 4C</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option value=\"1\" class=\"text-dark\">United States</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option value=\"2\" class=\"text-dark\">Canada</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                                <option value=\"3\" class=\"text-dark\">France</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            </select>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-font-size position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Zip Code</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <input type=\"number\" class=\"form-control ps-5 text-gray-light h-55\" placeholder=\"Enter number\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-hashtag position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Order Notes :</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <textarea class=\"form-control ps-5 text-dark\" placeholder=\"Some demo text ... \" cols=\"30\" rows=\"5\"></textarea>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-information-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20 pt-2\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group d-flex gap-3\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <button class=\"btn btn-primary bg-primary bg-opacity-10 text-primary py-3 px-5 fw-semibold border-0\">Back</button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <button class=\"btn btn-primary py-3 px-5 fw-semibold text-white\">Next</button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </form>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"tab-pane fade\" id=\"step7-tab-pane\" role=\"tabpanel\" aria-labelledby=\"step7-tab\" tabindex=\"0\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <h4 class=\"fs-18 fw-semibold\">Social Information</h4>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <p class=\"text-gray-light mb-4\">Fill all Information as below</p>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <form>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"row\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Facebook</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <input type=\"text\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"URL\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-facebook-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Twitter</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <input type=\"text\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"URL\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-twitter-x-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">Linkedin</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <input type=\"email\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"URL\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-linkedin-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-6\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <label class=\"label\">YouTube</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <input type=\"number\" class=\"form-control text-dark ps-5 h-55\" placeholder=\"URL\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <i class=\"ri-youtube-line position-absolute top-50 start-0 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-lg-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"form-group d-flex gap-3\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <button class=\"btn btn-primary bg-primary bg-opacity-10 text-primary py-3 px-5 fw-semibold border-0\">Back</button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <button type=\"submit\" class=\"btn btn-primary py-3 px-5 fw-semibold text-white\">Submit</button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </form>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</div>"),
                  _createTextVNode("\n")
                ]),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ])))
}